export type Trend = "up" | "down" | "flat";

export interface RankItem {
  rank: number;
  title: string;
  summary: string;
  category: string;
  heat: string;
  heatValue: number;
  trend: Trend;
  cover?: string;
  comments: number;
}

export interface CollectionItem {
  id: string;
  title: string;
  desc: string;
  count: number;
  tag: string;
  cover: string;
}

export interface BoardItem {
  rank: number;
  title: string;
  heat: string;
  trend: Trend;
}

export interface PickItem {
  title: string;
  summary: string;
  category: string;
  author: string;
  time: string;
  read: string;
}

export interface StatItem {
  value: string;
  label: string;
  note: string;
}

export const heroStats = [
  { value: "128,640", label: "累计收录条目", note: "持续整理中" },
  { value: "1,284", label: "今日更新", note: "每 10 分钟刷新" },
  { value: "86", label: "专题合集", note: "按事件归档" },
];

export const hotRanking: RankItem[] = [
  {
    rank: 1,
    title: "某 L 姓男演员深夜聚餐照流出，同框身份引发连锁猜测",
    summary: "多张现场图在讨论区被反复比对，时间线与当日行程存在两处对不上，粉丝与路人各执一词。",
    category: "吃瓜前线",
    heat: "286.4万",
    heatValue: 2864000,
    trend: "up",
    comments: 4218,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photo%20of%20an%20empty%20late%20night%20street%20table%20scene%20with%20warm%20amber%20lamp%20light%2C%20blurred%20silhouettes%20in%20shadow%2C%20crimson%20and%20gold%20color%20grade%2C%20mysterious%20mood%2C%20no%20text%2C%20no%20faces%2C%20magazine%20quality&width=800&height=600&seq=rank-01&orientation=landscape",
  },
  {
    rank: 2,
    title: "选秀出身的 S 姓歌手直播翻车，十分钟片段被反复剪辑",
    summary: "一段口误片段在两小时内二次传播过万，团队尚未正面回应，直播间回放已被设为不可见。",
    category: "直播热点",
    heat: "245.1万",
    heatValue: 2451000,
    trend: "up",
    comments: 3876,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20live%20stream%20studio%20scene%20with%20glowing%20red%20on%20air%20light%2C%20microphone%20silhouette%2C%20dark%20warm%20background%2C%20gold%20rim%20light%2C%20dust%20particles%2C%20cinematic%20no%20text%20no%20faces%2C%20editorial%20photography&width=800&height=600&seq=rank-02&orientation=landscape",
  },
  {
    rank: 3,
    title: "热播剧女二被指改剧本，剧组内部聊天记录曝光",
    summary: "流出的对话截图显示两处台词调整时间点，制片方回应称属于正常创作讨论，未涉改戏。",
    category: "剧组风云",
    heat: "198.7万",
    heatValue: 1987000,
    trend: "flat",
    comments: 2964,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20film%20set%20clapperboard%20and%20folded%20script%20pages%20on%20a%20dark%20wood%20table%2C%20warm%20amber%20practical%20light%2C%20deep%20crimson%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20text%20no%20faces%2C%20editorial%20product%20photography&width=800&height=600&seq=rank-03&orientation=landscape",
  },
  {
    rank: 4,
    title: "老牌综艺常驻阵容生变，知情人士透露两条线索",
    summary: "节目组官微海报构图出现空位，网友据此推测嘉宾更替，多方回应均保持暧昧。",
    category: "综艺观察",
    heat: "176.3万",
    heatValue: 1763000,
    trend: "up",
    comments: 2510,
    cover: "https://readdy.ai/api/search-image?query=Stylized%20empty%20tv%20variety%20show%20stage%20with%20row%20of%20spotlights%20and%20warm%20golden%20haze%2C%20red%20curtain%20edge%2C%20dark%20atmospheric%20background%2C%20no%20text%20no%20faces%2C%20cinematic%20editorial%20look&width=800&height=600&seq=rank-04&orientation=landscape",
  },
  {
    rank: 5,
    title: "K 姓导演新片选角名单流出，三位顶流被点名",
    summary: "一份标注日期的试镜表在圈内群流转，名单上的档期与公开行程存在重叠，真伪待考证。",
    category: "影视前瞻",
    heat: "154.9万",
    heatValue: 1549000,
    trend: "down",
    comments: 2144,
  },
  {
    rank: 6,
    title: "顶流情侣疑似取关，时间线对比图刷屏讨论区",
    summary: "双方社交账号互动记录被逐条截图整理，早期合照仍在，近期互动归零成为焦点。",
    category: "感情线",
    heat: "143.2万",
    heatValue: 1432000,
    trend: "up",
    comments: 3987,
  },
  {
    rank: 7,
    title: "M 姓小花造型争议升级，造型团队连夜回应",
    summary: "红毯礼服与品牌秀场款高度相似，造型团队称借鉴风格，未使用同款物料。",
    category: "造型图鉴",
    heat: "128.6万",
    heatValue: 1286000,
    trend: "flat",
    comments: 1733,
  },
  {
    rank: 8,
    title: "音乐节压轴歌手临时换人，主办方回应含糊",
    summary: "演出前两小时官宣调整，已购票观众要求说法，主办方仅表示因不可抗力因素。",
    category: "现场直击",
    heat: "112.4万",
    heatValue: 1124000,
    trend: "down",
    comments: 1456,
  },
  {
    rank: 9,
    title: "某组合合约风波反转，又一版本聊天截图出现",
    summary: "新截图与早前版本在时间戳上互相矛盾，双方各自宣布将保留法律追究权利。",
    category: "合约风波",
    heat: "98.2万",
    heatValue: 982000,
    trend: "up",
    comments: 1208,
  },
  {
    rank: 10,
    title: "老戏骨采访片段被断章取义，完整版澄清发布",
    summary: "完整采访视频上线后，原片段被指截断前后语境，多个账号已删除转发内容。",
    category: "澄清专区",
    heat: "86.5万",
    heatValue: 865000,
    trend: "down",
    comments: 964,
  },
];

export const collections: CollectionItem[] = [
  {
    id: "col-01",
    title: "年度翻车图鉴",
    desc: "按时间线收拢整年被反复提及的口误、翻车与公关应对，配关键节点截图索引。",
    count: 128,
    tag: "合集",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20collage%20of%20crumpled%20paper%20and%20fragments%20floating%20on%20deep%20crimson%20background%2C%20warm%20gold%20accent%20light%2C%20abstract%20editorial%20art%2C%20no%20text%20no%20faces%2C%20high%20contrast&width=800&height=560&seq=col-01&orientation=landscape",
  },
  {
    id: "col-02",
    title: "直播名场面合集",
    desc: "整理高热度直播瞬间与后续回应，标注发生时间、平台和处理结果。",
    count: 96,
    tag: "直播",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20dark%20broadcast%20control%20room%20with%20glowing%20red%20indicator%20lights%20and%20monitor%20silhouettes%2C%20warm%20amber%20haze%2C%20abstract%20editorial%20art%2C%20no%20text%20no%20faces&width=800&height=560&seq=col-02&orientation=landscape",
  },
  {
    id: "col-03",
    title: "剧组幕后时间线",
    desc: "以开机到杀青为轴，梳理剧组的角色调整、档期变动与官方说明。",
    count: 73,
    tag: "影视",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20backstage%20of%20a%20film%20set%20with%20ladder%20cables%20and%20warm%20spotlight%20beams%2C%20dark%20crimson%20tones%2C%20abstract%20editorial%20art%2C%20no%20text%20no%20faces&width=800&height=560&seq=col-03&orientation=landscape",
  },
  {
    id: "col-04",
    title: "造型争议档案",
    desc: "收录红毯、舞台与街拍造型引发的讨论，附设计团队公开说明。",
    count: 64,
    tag: "时尚",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20fashion%20atelier%20scene%20with%20dress%20form%20and%20hanging%20fabric%20in%20warm%20gold%20light%2C%20deep%20red%20backdrop%2C%20abstract%20editorial%20art%2C%20no%20text%20no%20faces&width=800&height=560&seq=col-04&orientation=landscape",
  },
  {
    id: "col-05",
    title: "合约风波全纪录",
    desc: "按公告发布日期归档的合约事件，含各方声明与后续进展。",
    count: 52,
    tag: "合约",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20desk%20with%20stacked%20contract%20documents%20sealed%20envelope%20and%20warm%20desk%20lamp%2C%20dark%20crimson%20background%2C%20abstract%20editorial%20art%2C%20no%20readable%20text%20no%20faces&width=800&height=560&seq=col-05&orientation=landscape",
  },
  {
    id: "col-06",
    title: "澄清与反转专区",
    desc: "专门收录被证伪的传闻与后续澄清，标注原始来源与更新时间。",
    count: 45,
    tag: "澄清",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20magnifying%20glass%20over%20abstract%20paper%20documents%20with%20warm%20gold%20light%20rays%2C%20deep%20crimson%20background%2C%20abstract%20editorial%20art%2C%20no%20text%20no%20faces&width=800&height=560&seq=col-06&orientation=landscape",
  },
];

export const timeBoards: Record<"day" | "week" | "month", BoardItem[]> = {
  day: [
    { rank: 1, title: "L 姓男演员聚餐照流出", heat: "286.4万", trend: "up" },
    { rank: 2, title: "S 姓歌手直播片段二次传播", heat: "245.1万", trend: "up" },
    { rank: 3, title: "热播剧女二改戏争议", heat: "198.7万", trend: "flat" },
    { rank: 4, title: "老牌综艺阵容生变", heat: "176.3万", trend: "up" },
    { rank: 5, title: "K 姓导演选角名单", heat: "154.9万", trend: "down" },
    { rank: 6, title: "顶流情侣取关疑云", heat: "143.2万", trend: "up" },
  ],
  week: [
    { rank: 1, title: "音乐节压轴换人事件", heat: "912.6万", trend: "up" },
    { rank: 2, title: "L 姓男演员聚餐照流出", heat: "843.2万", trend: "up" },
    { rank: 3, title: "组合合约风波反转", heat: "768.4万", trend: "up" },
    { rank: 4, title: "红毯造型归属争议", heat: "702.1万", trend: "flat" },
    { rank: 5, title: "S 姓歌手直播片段", heat: "655.8万", trend: "down" },
    { rank: 6, title: "老戏骨采访被断章取义", heat: "598.3万", trend: "down" },
  ],
  month: [
    { rank: 1, title: "年度翻车图鉴热度登顶", heat: "3,214万", trend: "up" },
    { rank: 2, title: "音乐节压轴换人事件", heat: "2,876万", trend: "up" },
    { rank: 3, title: "组合合约风波全纪录", heat: "2,540万", trend: "flat" },
    { rank: 4, title: "剧组幕后时间线合集", heat: "2,118万", trend: "up" },
    { rank: 5, title: "造型争议档案", heat: "1,905万", trend: "down" },
    { rank: 6, title: "澄清与反转专区", heat: "1,688万", trend: "up" },
  ],
};

export const tagList = [
  "吃瓜前线",
  "直播热点",
  "剧组风云",
  "综艺观察",
  "影视前瞻",
  "感情线",
  "造型图鉴",
  "现场直击",
  "合约风波",
  "澄清专区",
  "音乐现场",
  "品牌代言",
  "红毯图鉴",
  "社交动态",
];

export const editorPicks: PickItem[] = [
  {
    title: "为什么同一条爆料，热度和讨论量会背道而驰",
    summary: "我们统计了本周 240 条条目，发现转发峰值与评论峰值往往相差 6 到 8 小时，这解释了榜单的滞后感。",
    category: "榜单解读",
    author: "31观察组",
    time: "2 小时前",
    read: "8 分钟",
  },
  {
    title: "一份截图的三个版本：如何核对时间戳",
    summary: "把流传的三个版本对齐到同一时区后，可以看到其中两份的创建时间被修改过，核对方法并不复杂。",
    category: "核对方法",
    author: "31核对组",
    time: "5 小时前",
    read: "6 分钟",
  },
  {
    title: "热度算法公开说明：我们如何排出这份榜单",
    summary: "综合搜索量、讨论增量、二次传播系数与来源可信度四项权重，每小时滚动计算一次热度值。",
    category: "规则说明",
    author: "31产品组",
    time: "昨天",
    read: "5 分钟",
  },
  {
    title: "当澄清跑不过谣言：反转区是怎么工作的",
    summary: "反转专区会把被证伪的条目与原爆料放在同一页面并标黄，保留完整修改记录便于回溯。",
    category: "产品笔记",
    author: "31编辑组",
    time: "昨天",
    read: "7 分钟",
  },
  {
    title: "本周最容易被误读的五个词",
    summary: "「知情人士」「内部群」「实锤」这类词在传播中的可信度差异很大，本文做个简单的拆解。",
    category: "吃瓜素养",
    author: "31观察组",
    time: "2 天前",
    read: "4 分钟",
  },
  {
    title: "合集为什么比单条更好追：归档逻辑小解",
    summary: "把零散条目按事件归档后，用户平均停留时长提升了 41%，也更容易看到事件的全貌。",
    category: "产品笔记",
    author: "31产品组",
    time: "3 天前",
    read: "6 分钟",
  },
];

export const siteStats: StatItem[] = [
  { value: "128,640", label: "累计收录条目", note: "覆盖 32 个分类" },
  { value: "1,284", label: "今日新增条目", note: "较昨日 +12%" },
  { value: "326,000", label: "今日浏览人次", note: "峰值在 21:00" },
  { value: "86", label: "在架专题合集", note: "每周新增约 6 个" },
];

export const navLinks = [
  { href: "#ranking", label: "热度榜" },
  { href: "#collections", label: "专题合集" },
  { href: "#boards", label: "时段榜" },
  { href: "#tags", label: "标签塔" },
  { href: "#picks", label: "编辑精选" },
];

export const footerColumns = [
  {
    title: "浏览",
    links: [
      { label: "黑料热度排行", href: "#ranking" },
      { label: "热门黑料合集", href: "#collections" },
      { label: "日周月榜单", href: "#boards" },
      { label: "标签导航", href: "#tags" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "热度规则说明", href: "#picks" },
      { label: "核对方法", href: "#picks" },
      { label: "澄清与更正", href: "#collections" },
      { label: "内容声明", href: "#footer-note" },
    ],
  },
  {
    title: "参与",
    links: [
      { label: "提交线索", href: "#footer-note" },
      { label: "纠错反馈", href: "#footer-note" },
      { label: "合集投稿", href: "#footer-note" },
      { label: "联系编辑部", href: "#footer-note" },
    ],
  },
];